import { TEST_IDS } from '@va/constants';
import { PageHeaderTooltip } from '@va/dashboard/ui/components';
import { CircleArrowIcon } from '@va/icons';
import { Button, fontWeights, Heading3 } from '@va/ui/design-system';
import classNames from 'classnames';
import { useMemo } from 'react';

type TitleAndContextMenuProps = {
  title: string | React.ReactNode;
  tooltipTransKey?: string;
  onBackClick?: () => void;
  onBackHover?: () => void;
  className?: string;
  size?: 'small' | 'large';
};

export const TitleAndContextMenu = ({
  title,
  tooltipTransKey = '',
  onBackClick,
  onBackHover,
  className,
  size = 'large',
}: TitleAndContextMenuProps) => {
  const backButton = useMemo(() => {
    if (!onBackClick) return null;

    return (
      <Button
        color='tertiary'
        className='mr-2'
        icon={() => (
          <CircleArrowIcon className={classNames({ 'w-[0.9375rem] h-[0.9375rem]': size === 'small' })} color='#3C3C3C' />
        )}
        onClick={onBackClick}
        onHover={onBackHover}
        data-testid={TEST_IDS.generic.buttons.back}
        size={size}
      />
    );
  }, [onBackClick, onBackHover, size]);

  return (
    <div
      className={classNames('flex flex-row items-center mr-4 flex-nowrap min-w-210 lg:min-w-auto truncate', className)}
    >
      {backButton}
      <PageHeaderTooltip
        title={title}
        baseKey={tooltipTransKey}
        trigger='click'
        render={(shouldShow: boolean) => (
          <Heading3
            data-testid={TEST_IDS.specific.pageTitle}
            colorClassName='text-gray-code'
            weight={fontWeights.semibold}
            className={classNames('truncate', {
              'underline-dashed cursor-default': shouldShow,
            })}
          >
            {title}
          </Heading3>
        )}
      />
    </div>
  );
};
